import { c as _c } from "react/compiler-runtime";
import { thousandize } from "../../../../util/formatting";
import { EffektSlider } from "../../../shared/components/EffektSlider/EffektSlider";
import { WealthCalculatorPeriodAdjustment } from "../../../shared/components/Graphs/Area/AreaGraph";
import { calculateWealthPercentile } from "./_util";
import styles from "./WealthCalculator.module.scss";
export type WealthCalculatorSliderConfig = {
  donation_percentage_input_configuration: {
    template_string: string;
  };
};
export const WealthCalculatorSlider: React.FC<{
  donationPercentage: number;
  setDonationPercentage: (value: number) => void;
  postTaxIncome: number;
  wealthMountainGraphData: {
    x: number;
    y: number;
  }[];
  equvivalizedIncome: number;
  adjustedPppFactor: number;
  periodAdjustment: WealthCalculatorPeriodAdjustment;
  config: WealthCalculatorSliderConfig;
}> = t0 => {
  const $ = _c(65);
  const {
    donationPercentage,
    setDonationPercentage,
    postTaxIncome,
    wealthMountainGraphData,
    equvivalizedIncome,
    adjustedPppFactor,
    periodAdjustment,
    config
  } = t0;
  let beforeDonationAmount;
  let beforeInput;
  let t1;
  if ($[0] !== config.donation_percentage_input_configuration.template_string) {
    const [t2, afterInput] = config.donation_percentage_input_configuration.template_string.split("{donationPercentageInput}");
    beforeInput = t2;
    const [t3, afterDonationAmount] = afterInput.split("{donationAmount}");
    beforeDonationAmount = t3;
    t1 = afterDonationAmount.split("{wealthPercentile}");
    $[0] = config.donation_percentage_input_configuration.template_string;
    $[1] = beforeDonationAmount;
    $[2] = beforeInput;
    $[3] = t1;
  } else {
    beforeDonationAmount = $[1];
    beforeInput = $[2];
    t1 = $[3];
  }
  const [beforeWealthPercentile, afterWealthPercentile] = t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  let wealthPercentile;
  if ($[4] !== adjustedPppFactor || $[5] !== beforeDonationAmount || $[6] !== beforeInput || $[7] !== donationPercentage || $[8] !== equvivalizedIncome || $[9] !== periodAdjustment || $[10] !== postTaxIncome || $[11] !== setDonationPercentage || $[12] !== wealthMountainGraphData) {
    const donationAmount = Math.round(postTaxIncome * (donationPercentage / 100));
    let t10;
    if ($[22] !== adjustedPppFactor || $[23] !== donationPercentage || $[24] !== equvivalizedIncome || $[25] !== periodAdjustment || $[26] !== wealthMountainGraphData) {
      t10 = calculateWealthPercentile(wealthMountainGraphData, equvivalizedIncome * (1 - donationPercentage / 100), periodAdjustment, adjustedPppFactor).toLocaleString("no-NB");
      $[22] = adjustedPppFactor;
      $[23] = donationPercentage;
      $[24] = equvivalizedIncome;
      $[25] = periodAdjustment;
      $[26] = wealthMountainGraphData;
      $[27] = t10;
    } else {
      t10 = $[27];
    }
    wealthPercentile = t10;
    let t11;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = [styles.calculator__input, styles.calculator__input_slider];
      $[28] = t11;
    } else {
      t11 = $[28];
    }
    t9 = t11.join(" ");
    t8 = styles.calculator__input__inner;
    t7 = styles.calculator__input__group;
    t4 = styles.calculator__input__group__percentage_text;
    if ($[29] !== beforeInput) {
      t5 = <span>{beforeInput}</span>;
      $[29] = beforeInput;
      $[30] = t5;
    } else {
      t5 = $[30];
    }
    let t12;
    if ($[31] !== donationPercentage) {
      t12 = donationPercentage.toString();
      $[31] = donationPercentage;
      $[32] = t12;
    } else {
      t12 = $[32];
    }
    let t13;
    if ($[33] !== setDonationPercentage) {
      t13 = e => {
        if (e.target.value !== "" || !isNaN(parseInt(e.target.value))) {
          setDonationPercentage(Math.min(Math.max(parseInt(e.target.value), 0), 100));
        } else {
          if (e.target.value === "") {
            setDonationPercentage(0);
          }
        }
      };
      $[33] = setDonationPercentage;
      $[34] = t13;
    } else {
      t13 = $[34];
    }
    let t14;
    if ($[35] !== t12 || $[36] !== t13) {
      t14 = <input type="text" className={styles.calculator__input__group__percentage_input} value={t12} data-cy="wealthcalculator-donation-percentage-input" onChange={t13} />;
      $[35] = t12;
      $[36] = t13;
      $[37] = t14;
    } else {
      t14 = $[37];
    }
    let t15;
    if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <span>%</span>;
      $[38] = t15;
    } else {
      t15 = $[38];
    }
    if ($[39] !== t14) {
      t6 = <div className={styles.calculator__input__group__percentage_input_wrapper}>{t14}{t15}</div>;
      $[39] = t14;
      $[40] = t6;
    } else {
      t6 = $[40];
    }
    t2 = beforeDonationAmount;
    t3 = thousandize(donationAmount);
    $[4] = adjustedPppFactor;
    $[5] = beforeDonationAmount;
    $[6] = beforeInput;
    $[7] = donationPercentage;
    $[8] = equvivalizedIncome;
    $[9] = periodAdjustment;
    $[10] = postTaxIncome;
    $[11] = setDonationPercentage;
    $[12] = wealthMountainGraphData;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = wealthPercentile;
  } else {
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
    wealthPercentile = $[21];
  }
  let t10;
  if ($[41] !== afterWealthPercentile || $[42] !== beforeWealthPercentile || $[43] !== t2 || $[44] !== t3 || $[45] !== wealthPercentile) {
    t10 = <span>{t2}{t3}{beforeWealthPercentile}{wealthPercentile}{afterWealthPercentile}</span>;
    $[41] = afterWealthPercentile;
    $[42] = beforeWealthPercentile;
    $[43] = t2;
    $[44] = t3;
    $[45] = wealthPercentile;
    $[46] = t10;
  } else {
    t10 = $[46];
  }
  let t11;
  if ($[47] !== t10 || $[48] !== t4 || $[49] !== t5 || $[50] !== t6) {
    t11 = <div className={t4}>{t5}{t6}{t10}</div>;
    $[47] = t10;
    $[48] = t4;
    $[49] = t5;
    $[50] = t6;
    $[51] = t11;
  } else {
    t11 = $[51];
  }
  let t12;
  if ($[52] !== donationPercentage || $[53] !== setDonationPercentage) {
    t12 = <EffektSlider min={0} max={50} value={donationPercentage} onChange={setDonationPercentage} />;
    $[52] = donationPercentage;
    $[53] = setDonationPercentage;
    $[54] = t12;
  } else {
    t12 = $[54];
  }
  let t13;
  if ($[55] !== t11 || $[56] !== t12 || $[57] !== t7) {
    t13 = <div className={t7}>{t11}{t12}</div>;
    $[55] = t11;
    $[56] = t12;
    $[57] = t7;
    $[58] = t13;
  } else {
    t13 = $[58];
  }
  let t14;
  if ($[59] !== t13 || $[60] !== t8) {
    t14 = <div className={t8}>{t13}</div>;
    $[59] = t13;
    $[60] = t8;
    $[61] = t14;
  } else {
    t14 = $[61];
  }
  let t15;
  if ($[62] !== t14 || $[63] !== t9) {
    t15 = <div className={t9}>{t14}</div>;
    $[62] = t14;
    $[63] = t9;
    $[64] = t15;
  } else {
    t15 = $[64];
  }
  return t15;
};